import { apiGet } from '../standardApi';

export const apiGetSlideshow = async () => {
    return apiGet('/Actuality/InfosSlideShows', 'application/json');
};

export const apiGetSlideshowNews = async () => {
    return apiGet('/Actuality/InfosActualities', 'application/json');
};